﻿import {IStorageAdapter} from "@2d-front-monorepo/core";

function canWriteToLocalStorage(): boolean {
	try {
		const key = "_localstorage_support_test";
		window.localStorage.setItem(key, "true");
		window.localStorage.removeItem(key);
		return true;
	} catch {
		return false;
	}
}

function isSupported(): boolean {
	if (typeof window !== "undefined" && window !== null && "localStorage" in window) {
		return canWriteToLocalStorage() || window.localStorage.length > 0
	}

	return false;
}

export default class LocalStorageAdapter<T> implements IStorageAdapter<T> {
	private static readonly _supported: boolean = isSupported();
	private readonly _prefix: string;

	constructor(prefix: string) {
		this._prefix = prefix;
	}

	public async load(): Promise<T | null> {
		if (!LocalStorageAdapter._supported) {
			return null;
		}

		try {
			const data = localStorage.getItem(this._prefix);
			return data ? JSON.parse(data) : null;
		} catch (error) {
			console.error("Failed to load state:", error);
			return null;
		}
	}

	public async save(data: T): Promise<void> {
		if (!LocalStorageAdapter._supported) {
			return;
		}

		try {
			localStorage.setItem(this._prefix, JSON.stringify(data));
		} catch (error) {
			console.error("Failed to save state:", error);
		}
	}
}
